<template>
  <v-card>
    <v-card-title class="title white--text text-h5">
      Master Facility Registry (MFR)
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="12">
        <v-sheet class="pa-4 primary lighten-2 mb-4">
          <v-text-field
              v-model="search"
              clear-icon="mdi-close-circle-outline"
              clearable
              dark
              flat
              hide-details
              label="Search for region, zone, or woreda..."
              solo-inverted
          ></v-text-field>
        </v-sheet>
      </v-col>
      <v-col cols="12">
        <v-treeview
            ref="treeview"
            :items="locationItems"
            :load-children="onRowClick"
            :search="search"
            activatable
            item-key="id"
            open-on-click
            return-object
        >
          <template v-slot:prepend="{ item }">
            <!--            <v-icon v-if="item.loading">mdi-cached</v-icon>-->
            <!--            <v-icon v-else-if="item.level < 4 && item.children.length === 0">mdi-chevron-right</v-icon>-->
            <v-icon v-if="item.level === 4">mdi-hospital-building</v-icon>
          </template>
        </v-treeview>
        <div v-if="loadingNodeId !== null" style="text-align: center;">
          <v-progress-circular
              :size="50"
              :width="4"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {MfrService} from "./mfr.service";

export default {
  data: () => ({
    search: null,
    loadingNodeId: null,
    tableloading: false,
    headers: [
      {text: "Id", value: "id"},
      {text: "Name", value: "name"},
    ],
    tableData: [],
    level: 1,
    title: "Federal Ministry of Health",
    locationItems: [
      {
        id: 'root',
        name: "Federal Ministry of Health",
        level: 1,
        children: []
      }
    ],
    expandedNodes: []  // Added to manage expanded nodes
  }),
  created() {
    this.fetchData(); // Fetch initial data
  },
  methods: {
    async fetchData(id = null, level = this.level) {
      this.tableloading = true;
      let res = null;
      try {
        if (level === 1) {
          res = await MfrService.getRegionsDrp();
        } else if (level === 2) {
          res = await MfrService.getZonesDrp(id);
        } else if (level === 3) {
          res = await MfrService.getWoredasDrp(id);
        } else if (level === 4) {
          res = await MfrService.getFacilitiesDrp(id);
        }

        if (res.status === 200) {
          this.tableData = res.data;
          const items = res.data.map(item => ({
            ...item,
            level,
            children: level < 4 ? [] : null,
            type: level === 4 ? 'facility' : undefined,
            loading: false
          }));

          if (id) {
            const parent = this.findNode(this.locationItems, id);
            if (parent) {
              parent.children = items;
            }
          } else {
            this.locationItems[0].children = items;
          }
        } else {
          this.$toast.error("There was a problem fetching data!");
        }
      } catch (error) {
        this.$toast.error("There was a problem fetching data!");
      } finally {
        this.tableloading = false;
      }
    },
    async onRowClick(item) {
      item = item?.id ? item : item[0];
      if (item.type === 'facility') return;

      if (item.children.length === 0 && !item.loading) {
        item.loading = true;
        this.loadingNodeId = item.id;
        await this.fetchData(item.id, item.level + 1);
        item.loading = false;
        this.loadingNodeId = null;
      }

      this.level = item.level + 1;
      this.title = item.name;
    },
    findNode(items, id) {
      for (const item of items) {
        if (item.id === id) return item;
        if (item.children && item.children.length) {
          const found = this.findNode(item.children, id);
          if (found) return found;
        }
      }
      return null;
    }
  }
};
</script>

<style scoped>
.title {
  background-color: #607d8b !important;
  border-color: #607d8b !important;
}
</style>
